import React, { useState, useEffect, ChangeEvent, useRef } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import {
  Tabs,
  Tab,
  Form,
  Col,
  Row,
  Button,
  Container,
  FloatingLabel,
} from "react-bootstrap";
import moment from "moment";
import TextInput from "../../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import {
  fetchPickListByGroupName,
  fetchCaseStakeholderList,
} from "../../../../services/CaseInformationApi";
import { useDispatch, useSelector } from "react-redux";
import { PICKLIST_GROUP_NAME } from "../../../../common/Constant";
import AdvanceSearchList from "../components/AdvanceSearchList";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  setAdvancedSearchData,
  resetAdvancedSearchData,
} from "../../../../redux/slice/AdvanceSearchSlice";
import { RootState } from "../../../../redux/Store";
import { clearSearchQuery } from "../../../../redux/slice/searchSlice";
import DateRangePicker from "../../../../common/CustomDateRangePicker";
import { STAKEHOLDER_LIST_CODE } from "../../../../common/Constant";
import EmployerDetailsCard from "../../Case_Subject/components/EmployeeDetailsCard";
import TimePicker from "../../../../common/TimePicker";
import { searchHospitalClinic } from "../../../../services/StakeholderApi";
import {
  AddedQMEDoctorHospitalList,
  AddedQMEDoctorList,
  fetcQMEDoctorList,
} from "../../../../services/ScheduleAppointmentApi";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import { formatDateTime } from "../../../../utils/dateUtils";
import { fetchDocumentCategory } from "../../../../services/UploadRecordsApi";

interface TabItem {
  label: string;
}

const TABS: TabItem[] = [
  { label: "Case info" },
  { label: "Parties" },
  { label: "Patient" },
  { label: "QME Schedule" },
  { label: "Records" },
];

interface AdvancedSearchPopupProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTab: string;
}

interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  medicareId?: string;
  providerName?: string;
  providerAddress?: string;
  countryName?: string;
}

const AdvancedSearch: React.FC<AdvancedSearchPopupProps> = ({
  isOpen,
  onClose,
  selectedTab = "Case info",
}) => {
  const [activeTab, setActiveTab] = useState(selectedTab);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Case info fields - separate state for each field
  const [caseId, setCaseId] = useState("");
  const [priorityIds, setPriority] = useState("");
  const [caseReviewTypeIds, setCaseReviewType] = useState("");
  const [claimNumber, setClaimNo] = useState("");
  const [wcabNumber, setWcabNo] = useState("");
  const [panelNumber, setPanelNo] = useState("");
  const [fileNumber, setFileNo] = useState("");
  const [caseName, setCaseName] = useState("");
  const [caseNumber, setCaseNumber] = useState("");
  const [adjNumber, setAdjNo] = useState("");
  const [caseStageIds, setcaseStageIds] = useState("");
  const [isSSNFocused, setIsSSNFocused] = useState(false);

  // Stakeholder info fields - separate state for each field
  const [clientIds, setclientIds] = useState("");
  const [applicantAttorneyIds, setapplicantAttorneyIds] = useState("");
  const [defenceAttorneyIds, setdefenceAttorneyIds] = useState("");
  const [insuranceIds, setinsuranceIds] = useState("");

  // Subject info fields - separate state for each field
  const [subjectName, setName] = useState("");
  const [ssn, setSsnNo] = useState("");
  const [dateOfIncidentFrom, setIncidentStartDate] = useState<string | null>(
    null,
  );
  const [dateOfIncidentTo, setIncidentEndDate] = useState<string | null>(null);
  const [employer, setEmployer] = useState("");
  const [injuryTypeIds, setInjuryTypeIds] = useState("");
  const [severityOfInjuryIds, setSeverityOfInjuryIds] = useState("");
  const [EmployerStakeholderIds, setEmployerStakeholderIds] = useState("");
  // Dropdown selection states
  const [selectedPriority, setSelectedPriority] = useState<(string | number)[]>(
    [],
  );
  const [sendSelectedPriority, setSendSelectedPriority] = useState<
    (string | number)[]
  >([]);
  const [selectedCaseReview, setSelectedCaseReview] = useState<
    (string | number)[]
  >([]);
  const [selectedCaseStage, setSelectedCaseStage] = useState<
    (string | number)[]
  >([]);
  const [selectedInjuryType, setSelectedInjuryType] = useState<
    (string | number)[]
  >([]);
  const [selectedSeverityOfInjury, setSelectedSeverityOfInjury] = useState<
    (string | number)[]
  >([]);
  const [selectedEmployer, setselectedEmployer] = useState<(string | number)[]>(
    [],
  );
  const [selectedClient, setselectedClient] = useState<(string | number)[]>([]);
  const [selectedApplicantAttrorney, setSelectedApplicantAttrorney] = useState<
    (string | number)[]
  >([]);
  const [selectedDefenceAttorney, setSelectedDefenceAttorney] = useState<
    (string | number)[]
  >([]);
  const [selectedInsurance, setSelectedInsurance] = useState<
    (string | number)[]
  >([]);

  // Dropdown options
  const [priorityOptions, setPriorityOptions] = useState<any[]>([]);
  const [caseReviewOptions, setCaseReviewOptions] = useState<any[]>([]);
  const [caseStageOptions, setCaseStageOptions] = useState<any[]>([]);
  const [injuryTypeOptions, setInjuryTypeOptions] = useState<any[]>([]);
  const [severityOfInjuryOptions, setSeverityOfInjuryOptions] = useState<any[]>(
    [],
  );
  const [empoyerOptions, setempoyerOptions] = useState<any[]>([]);
  const [clientOptions, setclientOptions] = useState<any[]>([]);
  const [applicantAttorneyOptions, setapplicantAttorneyOptions] = useState<
    any[]
  >([]);
  const [defenceAttorneyOptions, setdefenceAttorneyOptions] = useState<any[]>(
    [],
  );
  const [insuranceOptions, setinsuranceOptions] = useState<any[]>([]);

  //states for QME Record
  const [appointmentConfirmationNo, setAppointmentNumber] = useState("");
  const [appintmentdateRange, setAppointmentdateRange] = useState<
    [Date | null, Date | null]
  >([null, null]);
  const [dateOfAppointmentStart, setAppointmentStartDate] = useState<
    string | null
  >(null);
  const [dateOfAppointmentEnd, setAppointmentEndDate] = useState<string | null>(
    null,
  );

  const [StartdateOfAppointment, setStartDateOfAppointment] = useState<Date>(
    new Date(),
  );
  const [startTime, setAppointmentStartTime] = useState<any>("");
  const [appointmentStatusOption, setAppointmentStatusOption] = useState<any[]>(
    [],
  );
  const [appointmentStatusIds, setAppointmentStatus] = useState<
    (string | number)[]
  >([]);

  const [selectedAppointmentStatus, setSelectedAppointmentStatus] = useState<
    (string | number)[]
  >([]);

  const [clinicOption, setClinicOption] = useState<any[]>([]);
  const [medicareIds, setClinicName] = useState<(string | number)[]>([]);

  const [selectedClinic, setSelectedClinic] = useState<(string | number)[]>([]);

  const [QMEDoctorOptions, setQMEDoctorOptions] = useState<any[]>([]);
  const [qMedDoctorIds, setQMEDoctor] = useState<(string | number)[]>([]);

  const [selectedQME, setSelectedQME] = useState<(string | number)[]>([]);

  const [qmeTypeOptions, setQMETypeOptions] = useState<any[]>([]);
  const [appointmentTypeIds, setQMEType] = useState<(string | number)[]>([]);

  const [selectedQMEType, setSelectedQMEType] = useState<(string | number)[]>(
    [],
  );
  const [qmeCategoryOptions, setQMECategoryOptions] = useState<any[]>([]);
  const [appointmentCategoryIds, setCategoryType] = useState<
    (string | number)[]
  >([]);

  const [selectedQMECategory, setSelectedQMECategory] = useState<
    (string | number)[]
  >([]);
  const [isInterpreterReq, setIsInterpreterReq] = useState<
    boolean | undefined
  >();

  const [medicalExamOptions, setMedicalExamOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const [ismedicalExam, setIsMedicalExam] = useState<string | null>(null);

  //Records Tab State

  const [documentTypeOptions, setDocumentTypeOptions] = useState<any[]>([]);
  const [documentTypeIds, setDocumentTypeIds] = useState<(string | number)[]>(
    [],
  );

  const [selectedDocumentTypeIds, setSelectedDocumentTypeIds] = useState<
    (string | number)[]
  >([]);

  const [documentCategoryOptions, setDocumentCategoryOptions] = useState<any[]>(
    [],
  );
  const [documentCategoryText, setDocumentCategoryText] = useState<
    (string | number)[]
  >([]);

  const [selectedDocumentCategoryIds, setSelectedDocumentCategoryIds] =
    useState<(string | number)[]>([]);
  const [uploadDateTime, setUploadDateTime] = useState<Date | null>(null);

  const [fileName, setFileName] = useState("");
  const [addlFileDesc, setAddlFileDesc] = useState("");
  const [uploadedByName, setUploadedByName] = useState("");
  const [additionalComments, setAdditionalComments] = useState("");

  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const startOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1,
  );

  const today = new Date();
  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([startOfMonth, today]);

  const [incidentdateRange, setincidentdateRange] = useState<
    [Date | null, Date | null]
  >([null, null]);
  const [dateOfRegistrationFrom, setRegistrationStartDate] = useState<
    string | null
  >(null);
  const [dateOfRegistrationTo, setRegistrationEndDate] = useState<
    string | null
  >(null);

  useEffect(() => {
    fetchPickListData();
  }, [loggedInUserid]);

  const handleStartTimeChange = (time: string) => {
    setAppointmentStartTime(time);
  };

  const fetchPickListData = async () => {
    try {
      const medicalOption = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Conduct_Medical_Exam,
        triggerById: loggedInUserid,
      });

      setMedicalExamOptions(medicalOption);

      const responsePriority = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Priority,
        triggerById: loggedInUserid,
      });
      setPriorityOptions(responsePriority);

      const responseCaseType = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
        triggerById: loggedInUserid,
      });
      setCaseReviewOptions(responseCaseType);

      const responseCaseStages = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Stages,
        triggerById: loggedInUserid,
      });
      setCaseStageOptions(responseCaseStages);

      const responseInjuryTypes = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Injury_Type,
        triggerById: loggedInUserid,
      });
      setInjuryTypeOptions(responseInjuryTypes);

      const responseSeverityOfInjury = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.SeverityOf_Injury,
        triggerById: loggedInUserid,
      });
      setSeverityOfInjuryOptions(responseSeverityOfInjury);

      const stakeholderCodes = {
        client: STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY,
        applicant: STAKEHOLDER_LIST_CODE.APPLICANT_ATTORNEY,
        defence: STAKEHOLDER_LIST_CODE.DEFENCE_ATTORNEY,
        insurance: STAKEHOLDER_LIST_CODE.INSURANCE,
        employer: STAKEHOLDER_LIST_CODE.EMPLOYER,
      };

      const responseClient = await fetchCaseStakeholderList(
        stakeholderCodes.client,
        "",
      );
      setclientOptions(responseClient);

      const responseApplicantAttorney = await fetchCaseStakeholderList(
        stakeholderCodes.applicant,
        "",
      );
      setapplicantAttorneyOptions(responseApplicantAttorney);
      const responseDefenceAttorney = await fetchCaseStakeholderList(
        stakeholderCodes.defence,
        "",
      );
      setdefenceAttorneyOptions(responseDefenceAttorney);

      const responseInsurance = await fetchCaseStakeholderList(
        stakeholderCodes.insurance,
        "",
      );
      setinsuranceOptions(responseInsurance);

      const responseEmployer = await fetchCaseStakeholderList(
        stakeholderCodes.employer,
        "",
      );
      setempoyerOptions(responseEmployer);

      const appointmentStatus = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Appointment_Status,
        triggerById: loggedInUserid,
      });

      setAppointmentStatusOption(appointmentStatus);

      const clinicName = await AddedQMEDoctorHospitalList();

      setClinicOption(clinicName);

      const doctorName = await AddedQMEDoctorList();

      setQMEDoctorOptions(doctorName);

      const qmeCategory = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Appointment_Category,
        triggerById: loggedInUserid,
      });

      setQMECategoryOptions(qmeCategory);

      const qmeType = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Appointment_Type,
        triggerById: loggedInUserid,
      });

      setQMETypeOptions(qmeType);

      const documentType = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Document_Category,
        triggerById: loggedInUserid,
      });

      setDocumentTypeOptions(documentType);

      const documentCategory = await fetchDocumentCategory();

      setDocumentCategoryOptions(documentCategory);
    } catch (error) {
      console.error("Error fetching picklist data:", error);
    }
  };

  // useEffect(() => {
  //   const handlePageRefresh = () => {
  //     localStorage.removeItem('advancedSearchForm');
  //     handleReset():

  //   };

  //   // Detect page refresh
  //   window.addEventListener('beforeunload', handlePageRefresh);

  //   return () => {
  //     window.removeEventListener('beforeunload', handlePageRefresh);
  //   };
  // }, []);

  const handleChange = (setter: React.Dispatch<React.SetStateAction<any>>) => {
    return (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      setter(e.target.value);
    };
  };

  const handleDateRangeChange = (newRange: [Date | null, Date | null]) => {
    const [start, end] = newRange;

    // Convert null values to undefined
    setDateRange([start ?? undefined, end ?? undefined]);

    setRegistrationStartDate(start ? moment(start).format("YYYY-MM-DD") : null);
    setRegistrationEndDate(end ? moment(end).format("YYYY-MM-DD") : null);
  };

  const handleIncidentDateChange = (data: [Date | null, Date | null]) => {
    setincidentdateRange(data);
    const [startDate, endDate] = data;
    setIncidentStartDate(
      startDate ? moment(startDate).format("YYYY-MM-DD") : null,
    );
    setIncidentEndDate(endDate ? moment(endDate).format("YYYY-MM-DD") : null);
  };
  const handleAppointmentDateChange = (data: [Date | null, Date | null]) => {
    setAppointmentdateRange(data);
    const [startDate, endDate] = data;
    setAppointmentStartDate(
      startDate ? moment(startDate).format("YYYY-MM-DD") : null,
    );
    setAppointmentEndDate(
      endDate ? moment(endDate).format("YYYY-MM-DD") : null,
    );
  };
  const handleSearch = async () => {
    const searchParams = {
      caseId,
      dateOfRegistrationFrom,
      dateOfRegistrationTo,
      dateOfIncidentFrom,
      dateOfIncidentTo,
      priorityIds,
      caseReviewTypeIds,
      claimNumber,
      wcabNumber,
      panelNumber,
      fileNumber,
      caseName,
      caseNumber,
      adjNumber,
      caseStageIds,
      subjectName,
      ssn,
      injuryTypeIds,
      severityOfInjuryIds,
      EmployerStakeholderIds,
      clientIds,
      applicantAttorneyIds,
      defenceAttorneyIds,
      insuranceIds,
      appointmentConfirmationNo,
      dateOfAppointmentStart,
      dateOfAppointmentEnd,
      startTime,
      appointmentStatusIds,
      currentPage: 1,
    };
    localStorage.setItem(
      "advancedSearchForm",
      JSON.stringify({
        caseId,
        dateOfRegistrationFrom,
        dateOfRegistrationTo,
        dateOfIncidentFrom,
        dateOfIncidentTo,
        priorityIds: selectedPriority,
        caseReviewTypeIds: selectedCaseReview,
        claimNumber,
        wcabNumber,
        panelNumber,
        fileNumber,
        caseName,
        caseNumber,
        adjNumber,
        caseStageIds: selectedCaseStage,
        subjectName,
        ssn,
        injuryTypeIds: selectedInjuryType,
        severityOfInjuryIds: selectedSeverityOfInjury,
        EmployerStakeholderIds: selectedEmployer,
        clientIds: selectedClient,
        applicantAttorneyIds: selectedApplicantAttrorney,
        defenceAttorneyIds: selectedDefenceAttorney,
        insuranceIds: selectedInsurance,
        appointmentConfirmationNo,
        dateOfAppointmentStart,
        dateOfAppointmentEnd,
        startTime: startTime
          ? formatDateTime(StartdateOfAppointment, startTime)
          : null,
        appointmentStatusIds: selectedAppointmentStatus,
        medicareIds: selectedClinic,
        qMedDoctorIds: selectedQME,
        appointmentCategoryIds: selectedQMECategory,
        appointmentTypeIds: selectedQMEType,
        isInterpreterRequired:
          isInterpreterReq === true ? 1 : isInterpreterReq === false ? 0 : null,

        medicalExamTypeId: ismedicalExam,
        documentTypeIds: selectedDocumentTypeIds,
        documentCategoryText: selectedDocumentCategoryIds,
        fileName: fileName,
        addlFileDesc: addlFileDesc,
        uploadedByName: uploadedByName,
        uploadDateTime: uploadDateTime ? formatDateTime(uploadDateTime) : null,
        additionalComments: additionalComments,
        currentPage: 1,
      }),
    );
    navigate("/advancesearch-case");

    setTimeout(() => {
      onClose();
    }, 100);
    dispatch(clearSearchQuery());
  };
  const handleReset = () => {
    localStorage.removeItem("advancedSearchForm");
    setCaseId("");
    setRegistrationStartDate(null);
    setRegistrationEndDate(null);
    setDateRange([undefined, undefined]);
    setincidentdateRange([null, null]);
    setSelectedPriority([]);
    setSelectedCaseReview([]);
    setClaimNo("");
    setWcabNo("");
    setPanelNo("");
    setFileNo("");
    setCaseName("");
    setCaseNumber("");
    setAdjNo("");
    setSelectedCaseStage([]);
    setName("");
    setSsnNo("");
    setSelectedInjuryType([]);
    setSelectedSeverityOfInjury([]);
    setselectedEmployer([]);
    setIncidentStartDate(null);
    setIncidentEndDate(null);
    setSelectedApplicantAttrorney([]);
    setSelectedDefenceAttorney([]);
    setselectedClient([]);
    setSelectedInsurance([]);
    setAppointmentNumber("");
    setAppointmentdateRange([null, null]);
    setAppointmentStartDate(null);
    setAppointmentStartTime("");
    setAppointmentStatus([]);
    setSelectedAppointmentStatus([]);
    setClinicName([]);
    setSelectedClinic([]);
    setQMEDoctor([]);
    setSelectedQME([]);
    setQMEType([]);
    setSelectedQME([]);
    setCategoryType([]);
    setSelectedQMEType([]);
    setIsInterpreterReq(undefined);
    setIsMedicalExam(null);
    setDocumentTypeIds([]);
    setSelectedDocumentTypeIds([]);
    setDocumentCategoryText([]);
    setSelectedDocumentCategoryIds([]);
    setFileName("");
    setUploadedByName("");
    setAddlFileDesc("");
    setAdditionalComments("");
    setUploadDateTime(null);
    dispatch(resetAdvancedSearchData());
  };

  useEffect(() => {
    if (isOpen) {
      const savedState = localStorage.getItem("advancedSearchForm");

      if (savedState) {
        const formData = JSON.parse(savedState);

        setCaseId(formData.caseId || "");
        setClaimNo(formData.claimNumber || "");
        setWcabNo(formData.wcabNumber || "");
        setPanelNo(formData.panelNumber || "");
        setFileNo(formData.fileNumber || "");
        setCaseName(formData.caseName || "");
        setCaseNumber(formData.caseNumber || "");
        setAdjNo(formData.adjNumber || "");
        setSelectedCaseStage(formData.caseStageIds);
        setName(formData.subjectName || "");
        setSsnNo(formData.ssn || "");
        setSelectedPriority(formData.priorityIds);
        setSelectedCaseReview(formData.caseReviewTypeIds);
        setSelectedInjuryType(formData.injuryTypeIds);
        setSelectedSeverityOfInjury(formData.severityOfInjuryIds);
        setIncidentStartDate(formData.dateOfIncidentFrom);
        setIncidentEndDate(formData.dateOfIncidentTo || undefined);
        setselectedEmployer(formData.EmployerStakeholderIds);
        setRegistrationStartDate(formData.dateOfRegistrationFrom || undefined);
        setRegistrationEndDate(formData.dateOfRegistrationTo || undefined);
        setselectedClient(formData.clientIds);
        setSelectedDefenceAttorney(formData.defenceAttorneyIds);
        setSelectedApplicantAttrorney(formData.applicantAttorneyIds);
        setSelectedInsurance(formData.insuranceIds);
        setDateRange([
          formData.dateOfRegistrationFrom,
          formData.dateOfRegistrationTo,
        ]);
        setincidentdateRange([
          formData.dateOfIncidentFrom,
          formData.dateOfIncidentTo,
        ]);
        setAppointmentNumber(formData.appointmentConfirmationNo);
        setAppointmentdateRange([
          formData.dateOfAppointmentStart,
          formData.dateOfAppointmentEnd,
        ]);
        setAppointmentStartTime(
          formData.startTime
            ? new Date(formData.startTime).toTimeString().slice(0, 5)
            : undefined,
        );

        setSelectedAppointmentStatus(formData.appointmentStatusIds);
        setSelectedClinic(formData.medicareIds);
        setSelectedQME(formData.qMedDoctorIds);
        setSelectedQMECategory(formData.appointmentCategoryIds);
        setSelectedQMEType(formData.appointmentTypeIds);

        setIsInterpreterReq(
          formData?.isInterpreterRequired === 1
            ? true
            : formData?.isInterpreterRequired === 0
              ? false
              : undefined,
        );

        if (formData?.medicalExamTypeId) {
          setIsMedicalExam(formData.medicalExamTypeId);
        } else {
          setIsMedicalExam(null);
        }

        setSelectedDocumentTypeIds(formData.documentTypeIds);
        setSelectedDocumentCategoryIds(formData.documentCategoryText);
        setFileName(formData.fileName);
        setAddlFileDesc(formData.addlFileDesc);
        setUploadedByName(formData.uploadedByName);
        setUploadDateTime(formData.uploadDateTime);
        setAdditionalComments(formData.additionalComments);
      }
    }
  }, [isOpen]);

  const handleMultiSelectChange = (
    selectedValues: (string | number)[],
    setState: React.Dispatch<React.SetStateAction<(string | number)[]>>,
  ) => {
    setState(selectedValues);
  };

  const oneYearAgo = new Date(
    today.getFullYear() - 1,
    today.getMonth(),
    today.getDate(),
  );

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        />
        <Dialog.Content
          className="dialogbox"
          style={{
            position: "fixed",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",

            borderRadius: "8px",
            minWidth: "1150px",
            maxWidth: "1300px",
            zIndex: "1001",
          }}
        >
          <Dialog.Title>Advanced Search</Dialog.Title>
          <button
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "0px",
              fontSize: "22px",
              cursor: "pointer",
              color: "#0092D5",
            }}
            onFocus={(e) =>
              (e.currentTarget.style.outline = "0px solid #0092D5")
            }
            onBlur={(e) => (e.currentTarget.style.outline = "none")}
            onClick={onClose}
          >
            &times;
          </button>

          <Container>
            <Row>
              <Col>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(key) => setActiveTab(key as string)}
                  className="mb-3 px-3 po-tab tabsection nav nav-tabs"
                >
                  {TABS.map((tab) => (
                    <Tab eventKey={tab.label} title={tab.label} key={tab.label}>
                      {tab.label === "Case info" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Case ID"
                                  name="caseId"
                                  value={caseId}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setCaseId(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setCaseId(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <div className="date-picker-container customDrodownControlDAtepicker">
                                  <DateRangePicker
                                    label="Date Of Registration"
                                    startDate={dateRange[0]}
                                    endDate={dateRange[1]}
                                    onChange={handleDateRangeChange}
                                  />
                                </div>
                              </Col>

                              <Col sm={3} className="selection_dropdown ">
                                <SearchableMultiSelectDropdown
                                  label="Priority"
                                  name="priority"
                                  options={priorityOptions} // Format: { value: string, label: string }
                                  values={selectedPriority}
                                  onChange={handleChange(setSelectedPriority)}
                                />
                              </Col>

                              <Col sm={3} className="selection_dropdown">
                                <SearchableMultiSelectDropdown
                                  label="Case(Review) Type"
                                  name="Select Case Review"
                                  options={caseReviewOptions}
                                  values={selectedCaseReview}
                                  onChange={handleChange(setSelectedCaseReview)}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Claim No."
                                  name="claimNo"
                                  value={claimNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setClaimNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setClaimNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="WCAB No."
                                  name="wcabNo"
                                  value={wcabNumber}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setWcabNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setWcabNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="Panel No."
                                  name="panelNo"
                                  value={panelNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setPanelNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setPanelNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="File No."
                                  name="fileNo"
                                  value={fileNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setFileNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setFileNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Case Name"
                                  name="caseName"
                                  value={caseName}
                                  maxLength={200}
                                  onChange={(e) =>
                                    setCaseName(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setCaseName(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="Case Number"
                                  name="caseNumber"
                                  value={caseNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setCaseNumber(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setCaseNumber(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="ADJ No."
                                  name="adjNo"
                                  value={adjNumber}
                                  maxLength={50}
                                  onChange={(e) =>
                                    setAdjNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setAdjNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Case Stage"
                                  name="Select Case Stage"
                                  options={caseStageOptions}
                                  values={selectedCaseStage}
                                  onChange={handleChange(setSelectedCaseStage)}
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "Parties" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Client"
                                  name="Select Client"
                                  options={clientOptions}
                                  values={selectedClient}
                                  onChange={handleChange(setselectedClient)}
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Applicant Attorney"
                                  name="Select Applicant Attorney"
                                  options={applicantAttorneyOptions}
                                  values={selectedApplicantAttrorney}
                                  onChange={handleChange(
                                    setSelectedApplicantAttrorney,
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Defense Attorney"
                                  name="Select Defence Attorney"
                                  options={defenceAttorneyOptions}
                                  values={selectedDefenceAttorney}
                                  onChange={handleChange(
                                    setSelectedDefenceAttorney,
                                  )}
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Insurance(Claims)"
                                  name="Select Insurance(Claims)"
                                  options={insuranceOptions}
                                  values={selectedInsurance}
                                  onChange={handleChange(setSelectedInsurance)}
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "Patient" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Name"
                                  name="name"
                                  value={subjectName}
                                  maxLength={100}
                                  onChange={(e) => setName(e.target.value)} // Trims spaces while typing
                                  onBlur={(e) => setName(e.target.value)} // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="SSN No."
                                  name="ssnNo"
                                  value={
                                    isSSNFocused
                                      ? ssn
                                      : ssn.length === 11
                                        ? `XXX-XX-${ssn.slice(-4)}`
                                        : ssn
                                  }
                                  maxLength={11}
                                  onChange={(e) =>
                                    setSsnNo(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setSsnNo(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Injury Type"
                                  name="Select Injury"
                                  options={injuryTypeOptions}
                                  values={selectedInjuryType}
                                  onChange={handleChange(setSelectedInjuryType)}
                                />
                              </Col>
                              <Col sm={3}>
                                <div className="date-picker-container customDrodownControlDAtepicker">
                                  <DateRangePicker
                                    startDate={
                                      incidentdateRange[0] ?? undefined
                                    }
                                    label="Date Of Incident"
                                    endDate={incidentdateRange[1] ?? undefined}
                                    onChange={handleIncidentDateChange}
                                    minDate={oneYearAgo}
                                    maxDate={today}
                                  />
                                </div>
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt mt-4"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Severity Of Injury"
                                  name="Select Severity"
                                  options={severityOfInjuryOptions}
                                  values={selectedSeverityOfInjury}
                                  onChange={handleChange(
                                    setSelectedSeverityOfInjury,
                                  )}
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt mt-4"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Employer"
                                  name="Employer"
                                  options={empoyerOptions}
                                  values={selectedEmployer}
                                  onChange={handleChange(setselectedEmployer)}
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "QME Schedule" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Appointment No"
                                  name="appointment"
                                  value={appointmentConfirmationNo}
                                  onChange={(e) =>
                                    setAppointmentNumber(e.target.value.trim())
                                  }
                                />
                              </Col>
                              <Col sm={3}>
                                <div className="date-picker-container customDrodownControlDAtepicker">
                                  <DateRangePicker
                                    label="Date Of Appointment"
                                    startDate={
                                      appintmentdateRange[0] ?? undefined
                                    }
                                    endDate={
                                      appintmentdateRange[1] ?? undefined
                                    }
                                    onChange={handleAppointmentDateChange}
                                  />
                                </div>
                              </Col>
                              <Col sm={3}>
                                <TimePicker
                                  selectedTime={startTime}
                                  onChange={handleStartTimeChange}
                                  label="Appointment Time"
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Status"
                                  name="Status"
                                  options={appointmentStatusOption}
                                  values={selectedAppointmentStatus}
                                  onChange={handleChange(
                                    setSelectedAppointmentStatus,
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Location"
                                  name="clinic"
                                  options={clinicOption}
                                  values={selectedClinic}
                                  onChange={handleChange(setSelectedClinic)}
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="QME Doctor"
                                  name="Status"
                                  options={QMEDoctorOptions}
                                  values={selectedQME}
                                  onChange={handleChange(setSelectedQME)}
                                />
                              </Col>
                            </Row>

                            <Row className="mt-3">
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Category"
                                  name="Category"
                                  options={qmeCategoryOptions}
                                  values={selectedQMECategory}
                                  onChange={handleChange(
                                    setSelectedQMECategory,
                                  )}
                                />
                              </Col>
                              <Col
                                sm={3}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Type"
                                  name="Status"
                                  options={qmeTypeOptions}
                                  values={selectedQMEType}
                                  onChange={handleChange(setSelectedQMEType)}
                                />
                              </Col>
                              <Col sm={3} className="d-flex align-items-center">
                                <div className="d-flex align-items-center gap-2">
                                  <label
                                    className="me-2"
                                    style={{ fontWeight: "500" }}
                                  >
                                    Interpreter Required{" "}
                                  </label>

                                  <label className="d-flex align-items-center">
                                    <input
                                      type="radio"
                                      name="interpreterRequired"
                                      checked={isInterpreterReq === true}
                                      onChange={() => setIsInterpreterReq(true)}
                                      className="me-1"
                                    />
                                    Yes
                                  </label>

                                  <label className="d-flex align-items-center">
                                    <input
                                      type="radio"
                                      name="interpreterRequired"
                                      checked={isInterpreterReq === false}
                                      onChange={() => {
                                        setIsInterpreterReq(false);
                                      }}
                                      className="me-1"
                                    />
                                    No
                                  </label>
                                </div>
                              </Col>
                              <Col
                                sm={3}
                                className="d-flex align-items-center px-0"
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <label
                                    className="me-1"
                                    style={{ fontWeight: "500" }}
                                  >
                                    Medical Exam{" "}
                                  </label>
                                  {medicalExamOptions?.map((option) => (
                                    <label key={option.value}>
                                      <input
                                        type="radio"
                                        name="ismedicalExam"
                                        value={option.value}
                                        checked={ismedicalExam === option.value}
                                        onChange={() =>
                                          setIsMedicalExam(option.value)
                                        }
                                      />
                                      <span className="ms-1">
                                        {option.label}
                                      </span>
                                    </label>
                                  ))}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                      {tab.label === "Records" && (
                        <Form>
                          <Container>
                            <Row className="mt-3">
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Document Type"
                                  name="Document Type"
                                  options={documentTypeOptions}
                                  values={selectedDocumentTypeIds}
                                  onChange={handleChange(
                                    setSelectedDocumentTypeIds,
                                  )}
                                />
                              </Col>
                              <Col
                                sm={6}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Category"
                                  name="Category"
                                  options={documentCategoryOptions}
                                  values={selectedDocumentCategoryIds}
                                  onChange={handleChange(
                                    setSelectedDocumentCategoryIds,
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={6}>
                                <TextInput
                                  label="File Name"
                                  name="filename"
                                  value={fileName}
                                  maxLength={100}
                                  onChange={(e) => setFileName(e.target.value)} // Trims spaces while typing
                                  onBlur={(e) => setFileName(e.target.value)} // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={6}>
                                <TextInput
                                  label="File Description"
                                  name="filedesc"
                                  value={addlFileDesc}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setAddlFileDesc(e.target.value)
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setAddlFileDesc(e.target.value)
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={3}>
                                <TextInput
                                  label="Uploaded By"
                                  name="uploadedBy"
                                  value={uploadedByName}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setUploadedByName(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setUploadedByName(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                              <Col sm={3}>
                                <FloatingLabelDatepicker
                                  label="Uploaded On"
                                  name="uploaded"
                                  value={uploadDateTime}
                                  onChange={(date: Date | null) => {
                                    setUploadDateTime(date);
                                  }}
                                  dateFormat="MM/dd/yyyy"
                                />
                              </Col>
                              <Col sm={6}>
                                <TextInput
                                  label="Additional Comments"
                                  name="additionalComments"
                                  value={additionalComments}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setAdditionalComments(e.target.value.trim())
                                  } // Trims spaces while typing
                                  onBlur={(e) =>
                                    setAdditionalComments(e.target.value.trim())
                                  } // Ensures trimming on focus loss
                                />
                              </Col>
                            </Row>
                          </Container>
                        </Form>
                      )}
                    </Tab>
                  ))}
                </Tabs>
              </Col>
            </Row>
            <hr></hr>
          </Container>

          <div className="d-flex justify-content-end  px-2 pb-3">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleReset}
            >
              <span className="material-icons mx-1">autorenew</span> Reset
            </Button>
            <Button
              variant="primary"
              className="btn btn-primary d-flex align-items-center mx-2"
              onClick={handleSearch}
            >
              <span className="material-icons">search</span>Search
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default AdvancedSearch;
